import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import styles from "./styles/PhotoBoothCreationPage.module.css";
import download from "../assests/share/download.svg";
import CameraMask from "../Components/CameraMask/CameraMask";

export default function PhotoBoothCreationPage() {
  const { occasion } = useParams();
  const [uploadErrorPopup, setUploadErrorPopup] = useState(false);
  const [photoBoothPopup, setPhotoBoothPopup] = useState(false);
  const [stream, setStream] = useState(null);
  const [source, setSource] = useState("");
  const inputRef = useRef();
  const [data, setData] = useState({});

  useEffect(() => {
    getData();
  }, []);
  const getData = async () => {
    try {
      let config = {
        method: "get",
        url: `https://storage.googleapis.com/goviral_home_data/photoBooth/${occasion}/data.json`,
      };
      let result = await axios(config);

      setData(result?.data);
    } catch (error) {
      console.log(error.message);
    }
  };
  console.log("data", data);

  const handleChoose = async () => {
    inputRef.current.click();
  };
  const handleFileChange = (event) => {
    setUploadErrorPopup(false);
    const file = event.target.files[0];
    const newFileUrl = URL.createObjectURL(file);
    setSource(newFileUrl);
  };

  const handleCapture = (imageData) => {
    if (!imageData || imageData.size === 0) {
      console.error("No image data or image data is empty.");
      return;
    }
    const file = imageData;
    const newFileUrl = URL.createObjectURL(file);
    setSource(newFileUrl);
    stopCamera();
    setPhotoBoothPopup(false);
  };
  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      setStream(null);
    }
  };
  const downloadImage = (e) => {
    // window.open(fullData?.qrCodeUrl)
    // e.preventDefault()

    fetch(source, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${data?.title} image.png`); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      {photoBoothPopup && (
        <CameraMask
          showPopup={photoBoothPopup}
          setShowPopup={setPhotoBoothPopup}
          handleCapture={handleCapture}
          stream={stream}
          setStream={setStream}
          handleChoose={handleChoose}
          contestDetails={data}
        />
      )}
      <div className={styles.posterContainer}>
        <div
          className="w-full h-full mb-[20px] rounded-b-[30px]"
          style={{
            background: `url(${data?.coverImage}) center center / cover`,
          }}
        >
          <div className="my-[20px] px-[54px]  flex flex-col items-center  ">
            <div className="flex gap-[16px] items-center w-[200px] justify-center">
              <button
                className={styles.filterChipsButton}
                style={{ backgroundColor: "white", color: "black" }}
              >
                <img
                  src={data?.icon}
                  alt=""
                  className="rounded-[16px] object-cover w-full h-full"
                />
              </button>
            </div>
            <p
              className={`${styles.textShadow} text-white font-bold text-[22px] leading-[24px] mt-[8px] capitalize text-center`}
            >
              {data?.title}
            </p>
          </div>
        </div>
        <div className=" w-full min-h-[20vh] flex flex-col items-center justify-center">
          <input
            type="file"
            onChange={handleFileChange}
            ref={inputRef}
            className="hidden"
            accept="image/*"
          />
          {source && (
            <div className=" w-[100%] px-[20px]">
              <div className="rounded-[30px] h-[320px] h-auto w-[100%] overflow-hidden flex items-start justify-center mb-[15px] bg-[#ececec] relative p-[10px]">
                <button
                  className="w-[24px] h-[24px] absolute top-[20px] right-[20px]"
                  onClick={downloadImage}
                >
                  <svg
                    width="16"
                    height="21"
                    viewBox="0 0 16 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.25 18.5H14.75C15.035 18.5001 15.3094 18.6084 15.5177 18.803C15.726 18.9976 15.8526 19.2639 15.872 19.5483C15.8915 19.8327 15.8022 20.1138 15.6224 20.3349C15.4425 20.5561 15.1854 20.7006 14.903 20.7395L14.75 20.75H1.25C0.964965 20.7499 0.690589 20.6416 0.482313 20.447C0.274037 20.2524 0.147389 19.9861 0.127961 19.7017C0.108533 19.4173 0.197773 19.1362 0.377649 18.9151C0.557525 18.6939 0.814625 18.5494 1.097 18.5105L1.25 18.5ZM7.847 0.5105L8 0.5C8.27186 0.500011 8.53451 0.598464 8.7394 0.777151C8.94428 0.955837 9.07753 1.20267 9.1145 1.472L9.125 1.625V13.157L12.5075 9.776C12.6983 9.58531 12.9512 9.46949 13.2202 9.44967C13.4892 9.42985 13.7563 9.50733 13.973 9.668L14.099 9.776C14.2897 9.96676 14.4055 10.2197 14.4253 10.4887C14.4452 10.7577 14.3677 11.0248 14.207 11.2415L14.099 11.3675L8.795 16.67C8.60452 16.8605 8.35199 16.9764 8.08332 16.9965C7.81466 17.0166 7.54771 16.9396 7.331 16.7795L7.205 16.67L1.901 11.3675C1.69971 11.1668 1.58188 10.8973 1.5712 10.6132C1.56051 10.3291 1.65777 10.0515 1.84342 9.83624C2.02906 9.62095 2.28933 9.48393 2.57189 9.45271C2.85445 9.4215 3.13834 9.49842 3.3665 9.668L3.4925 9.776L6.875 13.16V1.625C6.87501 1.35314 6.97346 1.09049 7.15215 0.885604C7.33084 0.680721 7.57767 0.547472 7.847 0.5105Z"
                      fill="black"
                    />
                  </svg>
                </button>
                <img
                  src={source}
                  className=" outline-none w-auto h-[100%] object-contain"
                />
              </div>
            </div>
          )}
          {!source && (
            <div className="w-[100%] text-center relative z-1 pt-[24px] px-[20px]">
              <p className="text-regular-medium mb-[10px] text-black">
                Take Photo
              </p>
              <p className="text-small mb-[24px] text-[#606060]">
                To capture your perfect moment, first click the Take Photo
                button. Next, choose your favorite frame in the pop-up and click
                Take Photo again to finalize your picture!
              </p>
            </div>
          )}
          <button
            onClick={() => setPhotoBoothPopup(true)}
            className="flex items-center justify-center mx-auto text-regular-medium commonButton"
            style={{
              backgroundColor: data?.buttonColor,
            }}
          >
            {source ? "Replace Photo" : "Take Photo"}
          </button>
        </div>
      </div>
    </>
  );
}
